import {Routes} from 'constants/index';
import {Permission, usePermissions} from 'hooks/usePermissions';

export type Group = {
	text: string
	links: Link[]
};

export type Link = {
	text: string
	link: string
	markdown?: string
};

export type Nav = 'site' | 'account';

export const useNav = (name: Nav): Group[] => {
	const {auth} = usePermissions();
	if (name === 'site') {
		return siteNav;
	} else if (auth.hasPermission(Permission.Developer)) {
		return [
			...accountNav,
			...developerNav,
		];
	}
	return accountNav;
};

const siteNav: Group[] = [
	{
		text: 'About',
		links: [
			{
				text: 'DEXA scans',
				link: '/blog/post/what_are_dexa_scans',
			},
		],
	},
	{
		text: 'Booking',
		links: [
			{
				text: 'Locations',
				link: Routes.booking,
			},
			{
				text: 'Pricing & memberships',
				link: Routes.pricingPkgs,
			},
			{
				text: 'Request a DEXA van',
				link: Routes.requestAVan,
			},
		],
	},
	{
		text: 'Insights',
		links: [
			{
				text: 'FAQs',
				link: '/blog/post/dexa_faq',
			},
			{
				text: 'Health hangouts',
				link: Routes.hangout,
			},
			{
				text: 'Blog',
				link: Routes.blog,
			},
		],
	},
];

const accountNav: Group[] = [
	{
		text: 'Home',
		links: [
			{
				text: 'View dashboard',
				link: Routes.dashboard,
			},
		],
	},
	{
		text: 'Your scans',
		links: [
			{
				text: 'Book a scan',
				link: Routes.booking,
			},
			{
				text: 'Appointments',
				link: Routes.bookedAppointments,
			},
			{
				text: 'Report builder (NEW!)',
				link: Routes.reportBuilder,
			},
			{
				text: 'PDF reports',
				link: Routes.reports,
			},
			{
				text: 'Health hangouts',
				link: Routes.hangout,
			},
		],
	},
	{
		text: 'Customer service',
		links: [
			{
				text: 'Contact us',
				link: Routes.support,
			},
		],
	},
	{
		text: 'Perks',
		links: [
			{
				text: 'Get free scans!',
				link: Routes.referrals,
				markdown: 'Get _free_ scans!',
			},
			{
				text: 'Transfer or share credits',
				link: Routes.gifting,
			},
		],
	},
	{
		text: 'Your account',
		links: [
			{
				text: 'Credits & memberships',
				link: Routes.account + '#credits-and-memberships',
			},
			{
				text: 'Transactions',
				link: Routes.transactions,
			},
			{
				text: 'Account settings',
				link: Routes.account,
			},
		],
	},
];

const developerNav: Group[] = [{
	text: 'Admin',
	links: [
		{
			text: 'Sandboxes',
			link: Routes.sandbox,
		},
		{
			text: 'AI Chats',
			link: Routes.assistant,
		},
	],
}];
